import { render, staticRenderFns } from "./edit-survey-page.vue?vue&type=template&id=877c3aaa&scoped=true&"
import script from "./edit-survey-page.vue?vue&type=script&lang=js&"
export * from "./edit-survey-page.vue?vue&type=script&lang=js&"
import style0 from "./edit-survey-page.vue?vue&type=style&index=0&id=877c3aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877c3aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('877c3aaa')) {
      api.createRecord('877c3aaa', component.options)
    } else {
      api.reload('877c3aaa', component.options)
    }
    module.hot.accept("./edit-survey-page.vue?vue&type=template&id=877c3aaa&scoped=true&", function () {
      api.rerender('877c3aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/edit-survey-page.vue"
export default component.exports